import { ProductPrice } from '~/Product';

import { ProductComputedPrice } from './ProductComputedPrice';

export class ReferencePrice {
	sourcePrice: ProductPrice;

	calculatedPrice: ProductComputedPrice;

	constructor(sourcePrice: ProductPrice, calculatedPrice: ProductComputedPrice) {
		this.sourcePrice = sourcePrice;
		this.calculatedPrice = calculatedPrice;
	}
}
